// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2goWj","left":"styles_left__14cPz","right":"styles_right__21D1S","alert":"styles_alert__20Pcn"};